/* unplugin-vue-components disabled */import script from "./GoodInfoTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoodInfoTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./GoodInfoTableBlock.vue?vue&type=style&index=0&id=f8798180&scoped=true&lang=less"
import "./GoodInfoTableBlock.vue?vue&type=style&index=1&id=f8798180&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8798180"]])

export default __exports__